import { memo, useMemo } from "react";
import GeoFencePill from "./GeoFencePill";

const GeoFencePills = ({
    value, color = "green", handleOpenUserGeofencesModal, handleOnClickLocation
}: {
    value: any;
    color?: "green" | "orange";
    handleOpenUserGeofencesModal: () => void;
    handleOnClickLocation: (item: any) => void;
}) => {
    const normalizedArray = useMemo(() => {
        if (!value) return [];
        if (Array.isArray(value)) {
            return value.filter((item: any) => item?.Name).map((item: any) => ({
                Id: item.Id,
                Name: item?.Name,
                Latitude: item.Latitude,
                Longitude: item.Longitude,
                GeoFenceTypeName: item.GeoFenceTypeName,

            })).filter(Boolean);
        }

        if (typeof value === "string") {
            return value.split(",").map(item => item.trim()).filter(Boolean);
        }
        return [];
    }, [value]);

    if (normalizedArray.length === 0) {
        return <span style={{ color: "#aaa" }}>No Geofence assigned</span>;
    }

    const visible = normalizedArray.slice(0, 2);
    const overflow = normalizedArray.length - 2;

    return (
        <div style={{ display: "block", maxWidth: "100%" }}>
            {visible?.map((item: any, index: any) => (
                <GeoFencePill key={index} item={item} color={color} handleOnClickLocation={() => handleOnClickLocation(item)} />
            ))}

            {overflow > 0 && (
                <span style={{
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "3px 8px",
                    borderRadius: "999px",
                    fontSize: "12px",
                    fontWeight: 500,
                    background: "#f0f0f0",
                    whiteSpace: "nowrap",
                    color: "#555",
                    border: "1px solid #ccc",
                    cursor: "pointer",
                    marginRight: "4px",
                    marginBottom: "4px",
                }}
                    onClick={handleOpenUserGeofencesModal}
                >
                    +{overflow}
                </span>
            )}
        </div>
    );
};

export default memo(GeoFencePills);